import { createScanEvent } from 'root/scan/ScanEvent';

/**
 * Method to call when a barcode scan is detected on a Web browser
 */
export const handleScanKeyboard = (barcode: string): void => {
  const $barcodeField = getFocusedInput();
  if ($barcodeField) {
    // input field is already populated with the barcode
    triggerBarcodeFieldReaction($barcodeField);
    return;
  }
  handleGlobalScan(barcode);
};

/**
 * Method to call when a barcode scan is detected on Retail Manager (iOS)
 */
export const handleScanSDK = (barcode: string): void => {
  const $barcodeField = getFocusedInput();
  if ($barcodeField) {
    populateBarcodeField($barcodeField, barcode);
    triggerBarcodeFieldReaction($barcodeField);
    return;
  }
  handleGlobalScan(barcode);
};

// Private methods

const handleGlobalScan = (barcode: string): void => {
  if (window.submit2DBarcodeScan) return;
  if ($('.prevent-global-scan').filter(':visible').length) return;
  if ($('.dispatch-global-scan').filter(':visible').length) {
    window.dispatchEvent(createScanEvent(barcode));
    return;
  }
  const $barcodeField = findGlobalBarcodeField();
  if (!$barcodeField) return;
  populateBarcodeField($barcodeField, barcode);
  triggerBarcodeFieldReaction($barcodeField);
};

// Helper methods

const getFocusedInput = (): JQuery<HTMLElement> | null => {
  if (!document.activeElement) return null;
  if (document.activeElement === document.body) return null;
  if (!(document.activeElement instanceof HTMLInputElement)) return null;
  if (!['text', 'search'].includes(document.activeElement.type)) return null;
  return $(document.activeElement);
};

const findGlobalBarcodeField = (): JQuery<HTMLElement> | null => {
  let $barcodeField = $(`
    .ReactModalPortal .inputbarcode,
    .ReactModalPortal .itembarcode,
    .ReactModalPortal .giftcardbarcode,
    .ReactModalPortal .receiptbarcode,
    .ReactModalPortal .customerbarcode,
    .ReactModalPortal .workorderbarcode
    `)
    .filter(':visible')
    .first();
  if ($barcodeField.length) return $barcodeField;
  $barcodeField = $(`
    .inputbarcode,
    .itembarcode,
    .giftcardbarcode,
    .receiptbarcode,
    .customerbarcode,
    .workorderbarcode
    `)
    .filter(':visible')
    .first();
  if ($barcodeField.length) return $barcodeField;
  return null;
};

const findGlobalBarcodeSubmit = (
  $barcodeField: JQuery<HTMLElement>
): JQuery<HTMLElement> | null => {
  const $barcodeSubmit = $barcodeField
    .closest('form')
    .find('button:contains(Search), .barcodesubmit')
    .filter(':visible')
    .first();
  if ($barcodeSubmit.length) return $barcodeSubmit;
  return null;
};

const populateBarcodeField = ($barcodeField: JQuery<HTMLElement>, barcode: string): void => {
  $barcodeField.trigger('focus');
  $barcodeField.val(barcode);
  $barcodeField.trigger('input');
  $barcodeField.trigger('change');
};

const triggerBarcodeFieldReaction = ($barcodeField: JQuery<HTMLElement>): void => {
  if (triggerBarcodeFieldAutoSubmit($barcodeField)) return;
  triggerBarcodeFieldSubmit($barcodeField);
};

/**
 * Important: Keyboard Enter key event will not work with React input fields
 * due to React synthetic events. A submit button must be clicked instead.
 * or the event keyboard handler must be bound to the native event.
 */
const triggerBarcodeFieldAutoSubmit = ($barcodeField: JQuery<HTMLElement>): boolean => {
  if ($barcodeField.hasClass('scanner-no-submit')) return true;
  if (!isFieldExpectingKeyEvents($barcodeField)) return false;
  $barcodeField.trigger($.Event('keypress', { which: 13, keyCode: 13, key: 'Enter' }));
  return true;
};

const triggerBarcodeFieldSubmit = ($barcodeField: JQuery<HTMLElement>): boolean => {
  const $barcodeSubmit = findGlobalBarcodeSubmit($barcodeField);
  if (!$barcodeSubmit) return false;
  $barcodeSubmit.trigger('click');
  return true;
};

const isFieldExpectingKeyEvents = ($barcodeField: JQuery<HTMLElement>): boolean => {
  const barcodeField: HTMLElement = $barcodeField[0];
  if (!(barcodeField instanceof HTMLInputElement)) return false;
  return !!(barcodeField.onkeydown || barcodeField.onkeyup || barcodeField.onkeypress);
};
